(function () {
  'use strict';

  /* ================================================================
     MOBILE FILTER SIDEBAR TOGGLE
  ================================================================ */
  var filterToggle = document.getElementById('filter-toggle');
  var filterDrawer = document.getElementById('filter-drawer');
  var filterBackdrop = document.getElementById('filter-backdrop');
  var filterDrawerClose = document.getElementById('filter-drawer-close');

  function openFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.add('is-open');
    if (filterBackdrop) filterBackdrop.classList.add('is-visible');
    document.body.classList.add('filter-open');
    document.documentElement.classList.add('filter-open');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
  }

  function closeFilterDrawer() {
    if (!filterDrawer) return;
    filterDrawer.classList.remove('is-open');
    if (filterBackdrop) filterBackdrop.classList.remove('is-visible');
    document.body.classList.remove('filter-open');
    document.documentElement.classList.remove('filter-open');
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'false');
  }

  if (filterToggle) {
    filterToggle.addEventListener('click', function (e) {
      if (e) e.preventDefault();
      if (filterDrawer && filterDrawer.classList.contains('is-open')) {
        closeFilterDrawer();
      } else {
        openFilterDrawer();
      }
    });
  }

  if (filterDrawerClose) {
    filterDrawerClose.addEventListener('click', closeFilterDrawer);
  }
  if (filterBackdrop) {
    filterBackdrop.addEventListener('click', closeFilterDrawer);
  }

  // Escape key to close
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') {
      closeFilterDrawer();
    }
  });

  /* ================================================================
     ACCORDION FILTER GROUPS LOGIC
  ================================================================ */
  var accordionItems = document.querySelectorAll('.filter-accordion-item');
  
  accordionItems.forEach(function (item) {
    var trigger = item.querySelector('.filter-accordion-trigger');
    var panel = item.querySelector('.filter-accordion-panel');
    var plusIcon = item.querySelector('.icon-plus');
    var minusIcon = item.querySelector('.icon-minus');
    if (!trigger || !panel) return;

    trigger.addEventListener('click', function () {
      var isExpanded = trigger.getAttribute('aria-expanded') === 'true';

      // Collapse all accordions first (exclusive single-open)
      accordionItems.forEach(function (otherItem) {
        var otherTrigger = otherItem.querySelector('.filter-accordion-trigger');
        var otherPanel = otherItem.querySelector('.filter-accordion-panel');
        var otherPlus = otherItem.querySelector('.icon-plus');
        var otherMinus = otherItem.querySelector('.icon-minus');
        if (otherTrigger && otherPanel) {
          otherTrigger.setAttribute('aria-expanded', 'false');
          otherPanel.style.maxHeight = '0px';
          if (otherPlus) otherPlus.style.display = 'block';
          if (otherMinus) otherMinus.style.display = 'none';
        }
      });

      // If it was not expanded, expand it
      if (!isExpanded) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.style.maxHeight = panel.scrollHeight + 'px';
        if (plusIcon) plusIcon.style.display = 'none';
        if (minusIcon) minusIcon.style.display = 'block';
      }
    });
  });

  /* ================================================================
     MULTI-SELECT FILTER DROPDOWNS
  ================================================================ */
  document.querySelectorAll('[data-multiselect]').forEach(function (ms) {
    var trigger = ms.querySelector('[data-ms-trigger]');
    var dropdown = ms.querySelector('.filter-multiselect__dropdown');
    if (!trigger || !dropdown) return;

    function open() {
      ms.setAttribute('data-open', '');
      dropdown.removeAttribute('hidden');
      trigger.setAttribute('aria-expanded', 'true');
    }

    function close() {
      ms.removeAttribute('data-open');
      dropdown.setAttribute('hidden', '');
      trigger.setAttribute('aria-expanded', 'false');
    }

    function toggle() {
      ms.hasAttribute('data-open') ? close() : open();
    }

    trigger.addEventListener('click', function (e) {
      /* Don't toggle if user clicked a chip link */
      if (e.target.closest('.filter-multiselect__chip')) return;
      toggle();
    });

    /* Close when clicking outside */
    document.addEventListener('click', function (e) {
      if (!ms.contains(e.target)) close();
    });

    /* Close on Escape */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') close();
    });
  });

  /* ================================================================
     SORT BY — navigate on change
  ================================================================ */
  var sortSelect = document.getElementById('sort-by');
  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var url = new URL(window.location.href);
      if (this.value === 'manual') {
        clearFilterParams(url);
        url.searchParams.delete('sort_by');
      } else {
        clearPriceParams(url);
        url.searchParams.set('sort_by', this.value);
        url.searchParams.delete('page');
      }
      window.location = url.toString();
    });
  }

  var sortCustom = document.querySelector('[data-sort-custom]');
  if (sortCustom) {
    var sortToggle = sortCustom.querySelector('.sort-custom__toggle');
    var sortMenu = sortCustom.querySelector('.sort-custom__menu');
    var sortOptions = sortCustom.querySelectorAll('[data-sort-value]');

    function getSortLabel(value) {
      switch (value) {
        case 'price-ascending':
          return 'Low to High';
        case 'price-descending':
          return 'High to Low';
        case 'created-descending':
          return 'Newest';
        case 'best-selling':
          return 'Best Seller';
        default:
          return 'Default';
      }
    }

    function syncSortUi(value) {
      var nextValue = value || 'manual';
      var toggleText = sortCustom.querySelector('.sort-custom__toggle-text');
      if (toggleText) {
        toggleText.textContent = getSortLabel(nextValue);
      } else if (sortToggle) {
        sortToggle.textContent = getSortLabel(nextValue);
      }
      if (sortSelect) sortSelect.value = nextValue;
      sortOptions.forEach(function (option) {
        option.classList.toggle('is-active', option.dataset.sortValue === nextValue);
      });
    }

    function closeSortMenu() {
      if (!sortMenu || !sortToggle) return;
      sortMenu.setAttribute('hidden', '');
      sortToggle.setAttribute('aria-expanded', 'false');
    }

    if (sortToggle && sortMenu) {
      var initialSortValue = new URL(window.location.href).searchParams.get('sort_by') || 'manual';
      syncSortUi(initialSortValue);

      sortToggle.addEventListener('click', function () {
        var isOpen = !sortMenu.hasAttribute('hidden');
        if (isOpen) {
          closeSortMenu();
        } else {
          sortMenu.removeAttribute('hidden');
          sortToggle.setAttribute('aria-expanded', 'true');
        }
      });

      sortOptions.forEach(function (option) {
        option.addEventListener('click', function () {
          syncSortUi(option.dataset.sortValue);
          closeSortMenu();

          var url = new URL(window.location.href);
          if (option.dataset.sortValue === 'manual') {
            clearFilterParams(url);
            url.searchParams.delete('sort_by');
          } else {
            clearPriceParams(url);
            url.searchParams.set('sort_by', option.dataset.sortValue);
            url.searchParams.delete('page');
          }
          window.location = url.toString();
        });
      });

      document.addEventListener('click', function (e) {
        if (!sortCustom.contains(e.target)) closeSortMenu();
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') closeSortMenu();
      });
    }
  }

  /* ================================================================
     DUAL PRICE RANGE SLIDER
  ================================================================ */
  document.querySelectorAll('.price-filter-group, #price-filter').forEach(function (priceWrap) {
    var inputMin   = priceWrap.querySelector('[data-price-min]');
    var inputMax   = priceWrap.querySelector('[data-price-max]');
    var fillEl     = priceWrap.querySelector('.price-range__fill');
    var minDisplay = priceWrap.querySelector('[data-price-min-display]');
    var maxDisplay = priceWrap.querySelector('[data-price-max-display]');
    if (!inputMin || !inputMax || !fillEl) return;

    var rangeMin = parseFloat(priceWrap.dataset.rangeMin) || 0;
    var rangeMax = parseFloat(priceWrap.dataset.rangeMax) || 1000000;
    var currentUrl = new URL(window.location.href);
    var requestedMin = parseFloat(currentUrl.searchParams.get('filter.v.price.gte'));
    var requestedMax = parseFloat(currentUrl.searchParams.get('filter.v.price.lte'));

    /* Normalize subunits if needed */
    if (!isNaN(requestedMin) && requestedMin > rangeMax * 10) {
      requestedMin = Math.round(requestedMin / 100);
    }
    if (!isNaN(requestedMax) && requestedMax > rangeMax * 10) {
      requestedMax = Math.round(requestedMax / 100);
    }

    if (!isNaN(requestedMax) && requestedMax > rangeMax) {
      rangeMax = requestedMax;
    }

    if (!isNaN(requestedMin)) {
      inputMin.value = requestedMin;
      if (requestedMin >= rangeMax) {
        rangeMax = requestedMin + Math.max(10000, requestedMin * 0.1);
      }
    }

    if (!isNaN(requestedMax)) {
      inputMax.value = requestedMax;
      if (requestedMax >= rangeMax) {
        rangeMax = requestedMax + Math.max(10000, requestedMax * 0.1);
      }
    }

    if (rangeMax <= rangeMin) {
      rangeMax = rangeMin + 10000;
    }

    inputMin.max = rangeMax;
    inputMax.max = rangeMax;

    function fmt(n) {
      return 'Rp' + Math.round(n).toLocaleString('id-ID');
    }

    function updateFill() {
      var lo = parseFloat(inputMin.value);
      var hi = parseFloat(inputMax.value);
      var span = rangeMax - rangeMin;
      var pctLeft = 0;
      var pctRight = 0;

      if (span > 0) {
        pctLeft  = ((lo - rangeMin) / span) * 100;
        pctRight = ((rangeMax - hi) / span) * 100;
      }

      pctLeft = Math.max(0, Math.min(pctLeft, 100));
      pctRight = Math.max(0, Math.min(pctRight, 100));
      fillEl.style.left  = pctLeft + '%';
      fillEl.style.right = pctRight + '%';
      if (minDisplay) minDisplay.textContent = fmt(lo);
      if (maxDisplay) maxDisplay.textContent = fmt(hi);
    }

    inputMin.addEventListener('input', function () {
      var lo = parseFloat(inputMin.value);
      var hi = parseFloat(inputMax.value);
      if (lo >= hi) inputMin.value = hi - 1;
      updateFill();
      schedulePriceApply();
    });

    inputMax.addEventListener('input', function () {
      var lo = parseFloat(inputMin.value);
      var hi = parseFloat(inputMax.value);
      if (hi <= lo) inputMax.value = lo + 1;
      updateFill();
      schedulePriceApply();
    });

    var priceTimer;
    function schedulePriceApply() {
      clearTimeout(priceTimer);
      priceTimer = setTimeout(applyPriceFilter, 600);
    }

    function applyPriceFilter() {
      var lo = Math.round(parseFloat(inputMin.value));
      var hi = Math.round(parseFloat(inputMax.value));
      var url = new URL(window.location.href);

      if (lo > rangeMin) {
        url.searchParams.set('filter.v.price.gte', lo);
      } else {
        url.searchParams.delete('filter.v.price.gte');
      }

      if (hi < rangeMax) {
        url.searchParams.set('filter.v.price.lte', hi);
      } else {
        url.searchParams.delete('filter.v.price.lte');
      }

      url.searchParams.delete('page');
      window.location = url.toString();
    }

    updateFill();
  });

  function clearFilterParams(url) {
    Array.from(url.searchParams.keys()).forEach(function (key) {
      if (key.startsWith('filter.') || key === 'page') {
        url.searchParams.delete(key);
      }
    });
  }

  function clearPriceParams(url) {
    url.searchParams.delete('filter.v.price.gte');
    url.searchParams.delete('filter.v.price.lte');
    url.searchParams.delete('page');
  }

  /* ================================================================
     CUSTOM VARIANT FILTER LOGIC
  ================================================================ */
  var variantRows = document.querySelectorAll('.filter-variant-row');
  if (variantRows.length) {
    var urlParams = new URLSearchParams(window.location.search);
    var activeVariantParam = urlParams.get('variant') || '';
    var clearBtn = document.getElementById('filter-drawer-clear');

    function applyVariantFilter(selectedVariant) {
      var gridItems = document.querySelectorAll('.product-grid__item');
      var matchedCount = 0;

      gridItems.forEach(function (item) {
        var variantsAttr = item.getAttribute('data-product-variants') || '';
        if (!selectedVariant) {
          item.style.display = '';
          matchedCount++;
        } else {
          var variantsList = variantsAttr.split('|||');
          var isMatch = variantsList.some(function (v) {
            return v.trim().toLowerCase() === selectedVariant.trim().toLowerCase();
          });
          if (isMatch) {
            item.style.display = '';
            matchedCount++;
          } else {
            item.style.display = 'none';
          }
        }
      });

      // Update clear all button state
      if (clearBtn && selectedVariant) {
        clearBtn.classList.remove('is-disabled');
      }

      // Update variant row active states
      variantRows.forEach(function (row) {
        var val = row.getAttribute('data-variant-filter') || '';
        var isChecked = selectedVariant && val.toLowerCase() === selectedVariant.toLowerCase();
        row.classList.toggle('is-checked', isChecked);
        row.setAttribute('aria-checked', isChecked ? 'true' : 'false');
      });
    }

    // Initial check on load
    if (activeVariantParam) {
      applyVariantFilter(activeVariantParam);
    }

    variantRows.forEach(function (row) {
      row.addEventListener('click', function (e) {
        e.preventDefault();
        var val = this.getAttribute('data-variant-filter') || '';
        var isCurrentlyChecked = this.classList.contains('is-checked');
        var nextVariant = isCurrentlyChecked ? '' : val;

        var url = new URL(window.location.href);
        if (nextVariant) {
          url.searchParams.set('variant', nextVariant);
        } else {
          url.searchParams.delete('variant');
        }
        window.history.replaceState({}, '', url.toString());

        applyVariantFilter(nextVariant);
      });
    });
  }

})();
